import type { Dominion } from "../../database/Dominion";
import { GadgetSystemDominionId } from "../../database/DominionLiterals";
import type { ModelField } from "../../database/ModelField";
import { BigCommerceStoreHashKey } from "./keys";

interface BigCommerceDominion extends Dominion {
  id: "bigcommerce/dominion/bigcommerce";
}

export const BigCommerceDominion: BigCommerceDominion = {
  id: "bigcommerce/dominion/bigcommerce" as const,
  name: "BigCommerce",
  sentenceName: "BigCommerce",
  description: "Data where BigCommerce is the source of truth",
  supportsMetadata() {
    return false;
  },
  supportsFieldValidations() {
    return false;
  },
  supportsFieldRemoval(field) {
    return field.key !== BigCommerceStoreHashKey;
  },
  supportsFieldDuplication() {
    return false;
  },
  supportsFieldTypeChanges() {
    return false;
  },
  supportsFieldRename() {
    return false;
  },
  supportsFieldFeature() {
    return false;
  },
  displaysFieldDataOffsite() {
    return true;
  },
  fieldIsWritablePublicly(field: ModelField) {
    return field.contributorConfiguration[GadgetSystemDominionId]?.isWritablePublicly ?? true;
  },
  fieldIsWritableInternally(field: ModelField) {
    return field.contributorConfiguration[GadgetSystemDominionId]?.isWritableInternally ?? true;
  },
};
